<!--  -->
<template>
  <div>
    <el-form
      :label-position="labelPosition"
      label-width="150px"
      :model="formLabelAlign"
    >
      <el-form-item label="规则名称">
        <el-input
          v-model="formLabelAlign.name"
          class="in_dwer"
        />
      </el-form-item>
      <el-form-item label="回传开关">
        <el-radio-group v-model="formLabelAlign.is_open">
          <el-radio-button :label="0">关闭</el-radio-button>
          <el-radio-button :label="1">开启</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="配置列表">
        <el-button type="primary" @click="getList">选择配置</el-button>
        <el-table
          border
          :data="formLabelAlign.rule_param"
        >
          <el-table-column
            label="名称"
            width="120px"
            prop="event_name"
          />
          <el-table-column
            label="配置"
            align="center"
          >
            <template scope="scope">
              <el-form-item>
                <div>
                  每条广告计划 每日先回传
                  <el-input-number
                    v-model="scope.row.part_pre_num"
                    size="mini"
                    :min="0"
                  /> 笔，再按如下策略进行回传
                </div>
              </el-form-item>
              <el-form-item>
                <el-radio-group v-model="scope.row.part_type">
                  <el-radio-button
                    :label="1"
                    style="margin-bottom: 10px;"
                  >百分比回传</el-radio-button>
                  <el-radio-button :label="2">循环比例回传<el-tooltip
                    content="选项左侧值为上报，右侧为不上报，默认5:1，如果选择2:1，就是第1笔不上报，第2，3笔上报，第4笔不上报，第5，6笔上报，如此循环"
                    placement="top"
                  >
                    <i
                      class="el-icon-info"
                      style="font-size: 15px;margin-left: 10px;"
                    />
                  </el-tooltip></el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-if=" scope.row.part_type == 1">
                <el-radio-group v-model="scope.row.part_rate">
                  <el-radio :label="10">10%</el-radio>
                  <el-radio :label="20">20%</el-radio>
                  <el-radio :label="30">30%</el-radio>
                  <el-radio :label="40">40%</el-radio>
                  <el-radio :label="50">50%</el-radio>
                  <el-radio :label="60">60%</el-radio>
                  <el-radio :label="70">70%</el-radio>
                  <el-radio :label="80">80%</el-radio>
                  <el-radio :label="90">90%</el-radio>
                  <el-radio :label="100">100%</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                v-if=" scope.row.part_type == 2"
                label="比例选择"
              >
                <el-select
                  v-model="scope.row.part_rate"
                  placeholder="比例选择"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item
                v-if=" scope.row.part_type == 2"
                label="循环规则"
              >
                <el-radio-group v-model="scope.row.part_loop_type">
                  <el-radio-button
                    :label="1"
                    style="margin-bottom: 10px;"
                  >按记录轮询</el-radio-button>
                  <el-radio-button :label="2">每日重置</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="是否回传全部账户">
        <el-radio-group v-model="formLabelAlign.is_all_account">
          <el-radio-button :label="0">否</el-radio-button>
          <el-radio-button :label="1">是</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="formLabelAlign.is_all_account === 0"
        label="请选择账户"
      >
        <el-button type="primary" size="mini" @click="addAccount">选择账号</el-button>
        <el-tag v-for="item,index in all_accounts" :key="index" closable style="margin-left: 10px" @close="removeAccount">{{ item }}</el-tag>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="sumbitr"
        >确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      :title="'选择账户'"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="50%"
    >
      <account ref="account" :account_list="all_accounts" @commit="addAccountList" @close="dialogVisible = false" />
    </el-dialog>
    <el-dialog
      :title="'选择配置'"
      :visible.sync="settingListVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="50%"
    >
      <div>
        <el-table
          :data="mpAdvertiserList"
          border
        >
          <el-table-column
            label="配置名称"
            align="center"
            prop="event_name"
          />
          <el-table-column
            label="操作"
            align="center"
          >
            <template slot-scope="{ row }">
              <el-button v-if="isSelected(row.event_name)" type="danger" @click="editSetting(true,row)">取消</el-button>
              <el-button v-else type="primary" @click="editSetting(false,row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <el-button type="info" @click="settingListVisible = false">取消</el-button>
        <el-button type="success" @click="settingListVisible = false">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { backRuleAdmincreate, backRuleAdminupdate, reportEventList } from '@/api/customer'
import Account from '@/views/backhaul/components/account.vue'
export default {
  components: { Account },
  data() {
    return {
      all_accounts: [],
      dialogVisible: false,
      labelPosition: 'right',
      type: 1,
      formLabelAlign: {
        name: '',
        is_open: 0,
        is_open_part: 0,
        rule_param: [],
        is_all_account: 1
      },
      copypart_rate: 100,
      options: [
        {
          value: 100,
          label: '1:1'
        },
        {
          value: 67,
          label: '2:3'
        },
        {
          value: 50,
          label: '1:2'
        },
        {
          value: 150,
          label: '3:2'
        },
        {
          value: 200,
          label: '2:1'
        },
        {
          value: 300,
          label: '3:1'
        },
        {
          value: 400,
          label: '4:1'
        },
        {
          value: 500,
          label: '5:1'
        },
        {
          value: 600,
          label: '6:1'
        },
        {
          value: 700,
          label: '7:1'
        },
        {
          value: 800,
          label: '8:1'
        },
        {
          value: 900,
          label: '9:1'
        }
      ],
      typer: 1,
      id: null,
      settingData: [{ event_name: 123123, part_type: 1 }],
      settingListVisible: false,
      mpAdvertiserList: null
    }
  },
  created() {},
  mounted() {},
  methods: {
    isSelected(eventName) {
      return this.formLabelAlign.rule_param.some(item => item.event_name === eventName)
    },
    typelist(value) {
      console.log('value', value)
    },
    sumbitr() {
      // eslint-disable-next-line eqeqeq
      if (this.formLabelAlign.name == '') {
        this.$message({
          message: '请填写规则名称',
          type: 'error'
        })
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.typer == 1) {
        const obj = {}
        //  是否回传全部账户
        if (this.formLabelAlign.is_all_account === 0 && this.all_accounts) {
          obj.account_list = this.all_accounts
        }
        // 是否开启回传部分订单
        if (this.formLabelAlign.is_open_part === 1) {
          obj.part_pre_num = this.formLabelAlign.part_pre_num
          // eslint-disable-next-line eqeqeq
          if (this.formLabelAlign.part_type == 1) {
            console.log('百分比')
            obj.part_rate = this.formLabelAlign.part_rate
          } else {
            obj.part_rate = this.copypart_rate
            obj.part_loop_type = this.formLabelAlign.part_loop_type
            console.log('循环比例回传')
          }
        }
        backRuleAdmincreate({
          name: this.formLabelAlign.name,
          is_open: this.formLabelAlign.is_open,
          is_open_part: this.formLabelAlign.is_open_part,
          ...obj,
          rule_param: this.formLabelAlign.rule_param,
          is_all_account: this.formLabelAlign.is_all_account
        }).then(res => {
          // eslint-disable-next-line eqeqeq
          if (res.code == 0) {
            this.$emit('updata')
            this.$message({
              message: '添加成功',
              type: 'success'
            })
          }
        })
      } else {
        const obj = {}
        //  是否回传全部账户
        if (this.formLabelAlign.is_all_account === 0 && this.all_accounts) {
          obj.account_list = this.all_accounts
        }
        // 是否开启回传部分订单
        if (this.formLabelAlign.is_open_part === 1) {
          obj.part_pre_num = this.formLabelAlign.part_pre_num
          // eslint-disable-next-line eqeqeq
          if (this.formLabelAlign.part_type == 1) {
            console.log('百分比')
            obj.part_rate = this.formLabelAlign.part_rate
          } else {
            obj.part_rate = this.copypart_rate
            obj.part_loop_type = this.formLabelAlign.part_loop_type
            console.log('循环比例回传')
          }
        }
        backRuleAdminupdate({
          id: this.id,
          status: 1,
          name: this.formLabelAlign.name,
          is_open: this.formLabelAlign.is_open,
          is_open_part: this.formLabelAlign.is_open_part,
          ...obj,
          rule_param: this.formLabelAlign.rule_param,
          is_all_account: this.formLabelAlign.is_all_account
        }).then(res => {
          // eslint-disable-next-line eqeqeq
          if (res.code == 0) {
            this.$emit('updata')
            this.$message({
              message: '修改成功',
              type: 'success'
            })
          }
        })
      }
    },
    addAccount() {
      this.dialogVisible = true
      console.log(1)
    },
    addAccountList(val) {
      this.all_accounts = val
      this.dialogVisible = false
    },
    removeAccount(val) {
      console.log(val)
      this.all_accounts.splice(val, 1)
    },
    send(type, val) {
      console.log(type)
      this.typer = type
      if (type === 2) {
        this.formLabelAlign = val
        this.all_accounts = val.account_ids
      }
      this.id = val.id
      console.log(val)
    },
    getList() {
      this.settingListVisible = true
      if (!this.mpAdvertiserList) {
        reportEventList().then(res => {
          console.log(res)
          this.mpAdvertiserList = res.data
        })
      }
    },
    editSetting(isDel, val) {
      if (isDel) {
        this.formLabelAlign.rule_param = this.formLabelAlign.rule_param.filter(item => item.event_type !== val.event_type)
      } else {
        this.formLabelAlign.rule_param.push({ event_name: val.event_name, event_type: val.event_type, part_type: 2, part_pre_num: 0, part_loop_type: 1, part_rate: 100, copypart_rate: 100 })
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.in_dwer {
  width: 400px;
}
</style>
